import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { products, profile } from "../../../../services";
import { IRootState } from "../../../../models/interface";
import i18n from "../../../../i18n";
import { IProfileState } from "./../../../../models/interface/IProfileState";
import { setLocalStorageUserInfo } from "../../../../utils/helpers";
import { USER_INFO } from "../../../../common/constant";
import IShippingInfo from "../../../../models/shippingInfoModel";
import {
  addOrUpdateShippingInfo,
  getUserInfoLocal,
  loadData,
  saveShippingInfo,
  saveWishesListLocal,
} from "../../../../services/profile";
import { getShoppingCart } from "../cart";
import { checkContextMenu } from "../../../../utils/helper";

const initialState: IProfileState = {
  shippingInfoList: [],
  wishesList: [],
};

export const profileSlice = createSlice({
  name: "profile",
  initialState: initialState,
  reducers: {
    profileLoading: (state) => {
      state.loading = true;
    },

    profileResetStatus: (state) => {
      state.loading = false;
      state.status = 0;
      state.message = "";
      // state.isUpdatted = false;
      // state.isGetted = false;
    },
    profileResetGettedStatus: (state) => {
      state.isGetted = false;
    },
    profileGetInfoSuccess: (state, action) => {
      state.loading = false;
      state.status = 200;
      state.isGetted = true;
      state.message = i18n.t("point_status_success");
      state.userInfo = action.payload;
    },
    profileGetInfoFail: (state, action) => {
      state.loading = false;
      state.status = action.payload.status;
      state.isGetted = false;
      state.message = action.payload.message;
    },

    profileResetUpdateStatus: (state) => {
      state.isUpdatted = false;
    },
    profileUpdateInfoSuccess: (state, action) => {
      state.loading = false;
      state.status = 200;
      state.isUpdatted = true;
      state.message = i18n.t("point_status_success");
    },
    actionUpdateShippingInfo: (state, action) => {
      state.shippingInfoList = action.payload;
    },
    profileUpdateInfoFail: (state, action) => {
      state.loading = false;
      state.status = action.payload.status;
      state.isUpdatted = false;
      state.message = action.payload.message;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setWishesList: (state, action) => {
      state.wishesList = action.payload;
    },
    setIsUpdattedAddress: (state, action) => {
      state.isUpdattedAddress = action.payload;
    },
  },
});

export const {
  profileLoading,
  profileResetStatus,
  profileResetGettedStatus,
  profileGetInfoSuccess,
  profileGetInfoFail,
  profileUpdateInfoSuccess,
  profileUpdateInfoFail,
  profileResetUpdateStatus,
  actionUpdateShippingInfo,
  setUserInfo,
  setWishesList,
  setIsUpdattedAddress,
} = profileSlice.actions;

export const resetStatus = () => (dispatch: Dispatch) => {
  dispatch(profileResetStatus());
};
export const resetUpdateStatus = () => (dispatch: Dispatch) => {
  dispatch(profileResetUpdateStatus());
};
export const resetGettedStatus = () => (dispatch: Dispatch) => {
  dispatch(profileResetGettedStatus());
};
export const getUserInfo = () => (dispatch: Dispatch) => {
  dispatch(profileResetStatus());
  dispatch(profileResetGettedStatus());
  dispatch(profileLoading());

  profile.profileGetInfo((data, err) => {
    if (data) {
      // localStorage.setItem(USER_INFO, JSON.stringify(data));
      const info = JSON.parse(`${localStorage.getItem(USER_INFO)}`);
      setLocalStorageUserInfo(data, info.delivery_infos);

      dispatch(profileGetInfoSuccess(data));
    } else {
      dispatch(profileGetInfoFail(err));
    }
  });
};

export const updateUserInfo = (query: any) => (dispatch: Dispatch) => {
  dispatch(profileResetStatus());
  dispatch(profileLoading());

  profile.profileUpdateInfo(query, (data, err) => {
    if (data) {
      dispatch(profileUpdateInfoSuccess(data));
    } else {
      dispatch(profileUpdateInfoFail(err));
    }
  });
};

export const addShippingInfo =
  (info: IShippingInfo) => async (dispatch: Dispatch) => {
    const shippingInfoList = await addOrUpdateShippingInfo(info);
    dispatch(actionUpdateShippingInfo(shippingInfoList));
    dispatch(getShoppingCart());
  };

export const loadUserInfo = () => (dispatch: Dispatch) => {
  const userInfo = getUserInfoLocal();
  dispatch(setUserInfo(userInfo));
};

export const getWishesList =
  (query: any = {}) =>
  (dispatch: Dispatch) => {
    products.getProductsWishV2(query, (data, err) => {
      if (data) {
        saveWishesListLocal(data.docs);
        dispatch(setWishesList(data.docs));
      }
    });
  };

export const actionLoadData = () => async (dispatch: Dispatch) => {
  checkContextMenu();
  const data = await loadData();

  if (data.userInfo) {
    setLocalStorageUserInfo(data.userInfo, []);
    dispatch(setUserInfo(data.userInfo));
  } else {
    loadUserInfo();
    dispatch(setUserInfo(null));
  }

  if (data.deliveries) {
    saveShippingInfo(data.deliveries);
    dispatch(actionUpdateShippingInfo(data.deliveries));
  } else {
    saveShippingInfo([]);
    dispatch(actionUpdateShippingInfo([]));
  }

  if (data.wishesList) {
    saveWishesListLocal(data.wishesList);
    dispatch(setWishesList(data.wishesList));
  } else {
    saveWishesListLocal([]);
    dispatch(setWishesList([]));
  }
};

export const selectProfile = (state: IRootState) => state.profile;
export const selectUserInfo = (state: IRootState) => state.profile.userInfo;
export const selectShippingInfoList = (state: IRootState) =>
  state.profile.shippingInfoList;
export const selectWishesList = (state: IRootState) => state.profile.wishesList;

export default profileSlice.reducer;
